module.exports = __webpack_public_path__ + "img/cutMind.795e722d.svg";